module.exports = __webpack_public_path__ + "static/media/sensor.e02e430e.jpg";